// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"440":"7964798e","484":"1bef058b","551":"2a37cce4","815":"cb0b7040"}[chunkId] + ".chunk.js";
};